import React from "react";
import { Link } from "react-router-dom";

export default ({ id }) => (
  <Link to={`/publishers/${id}`} className="btn btn-default btn-xs">
    <i className="glyphicon glyphicon-signal" />
    <span>Детальная статистика</span>
  </Link>
);
